import { useEffect, useState } from "react";
import styles from "./Spinner.module.css";
import { useTheme } from "../../context/ThemeContext";

function Spinner({ size = "l" }) {
  const { theme } = useTheme();
  const [opacityArr, setOpacityArr] = useState([1, 0.87, 0.75, 0.63, 0.51, 0.39, 0.27, 0.15]);

  let width = size === "l" ? 32 : 22;

  useEffect(() => {
    const handle = setInterval(() => {
      setOpacityArr((arr) => {
        let [first, ...rest] = arr;
        return [...rest, first];
      });
    }, 120);
    return () => {
      clearInterval(handle);
    };
  }, []);

  const isDark = theme === "dark";

  return (
    <>
      {!isDark ? (
        <LightSpinner opacityArr={opacityArr} width={width} />
      ) : (
        <DarkSpinner opacityArr={opacityArr} width={width} />
      )}
    </>
  );
}

function DarkSpinner({ opacityArr, width }) {
  return (
    <svg width={width} height={width} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity={opacityArr[0]} x="9.5" width="3" height="7" rx="1.5" fill="#EBEBF5" fillOpacity="0.6" />
      <rect
        opacity={opacityArr[1]}
        x="2.16016"
        y="4.28223"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(-45 2.16016 4.28223)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
      <rect
        opacity={opacityArr[2]}
        x="7"
        y="9.5"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(90 7 9.5)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />

      <rect
        opacity={opacityArr[3]}
        x="7.10938"
        y="12.7678"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(45 7.10938 12.7678)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
      <rect opacity={opacityArr[4]} x="9.5" y="15" width="3" height="7" rx="1.5" fill="#EBEBF5" fillOpacity="0.6" />
      <rect
        opacity={opacityArr[5]}
        x="12.7695"
        y="14.8887"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(-45 12.7695 14.8887)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
      <rect
        opacity={opacityArr[6]}
        x="22"
        y="9.5"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(90 22 9.5)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
      <rect
        opacity={opacityArr[7]}
        x="17.7188"
        y="2.16113"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(45 17.7188 2.16113)"
        fill="#EBEBF5"
        fillOpacity="0.6"
      />
    </svg>
  );
}

function LightSpinner({ opacityArr, width }) {
  return (
    <svg width={width} height={width} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity={opacityArr[0]} x="9.5" width="3" height="7" rx="1.5" fill="#3C3C43" fillOpacity="0.6" />
      <rect
        opacity={opacityArr[1]}
        x="2.16016"
        y="4.28223"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(-45 2.16016 4.28223)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />

      <rect
        opacity={opacityArr[2]}
        x="7"
        y="9.5"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(90 7 9.5)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />

      <rect
        opacity={opacityArr[3]}
        x="7.10938"
        y="12.7678"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(45 7.10938 12.7678)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />
      <rect opacity={opacityArr[4]} x="9.5" y="15" width="3" height="7" rx="1.5" fill="#3C3C43" fillOpacity="0.6" />
      <rect
        opacity={opacityArr[5]}
        x="12.7695"
        y="14.8887"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(-45 12.7695 14.8887)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />
      <rect
        opacity={opacityArr[6]}
        x="22"
        y="9.5"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(90 22 9.5)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />
      <rect
        opacity={opacityArr[7]}
        x="17.7188"
        y="2.16113"
        width="3"
        height="7"
        rx="1.5"
        transform="rotate(45 17.7188 2.16113)"
        fill="#3C3C43"
        fillOpacity="0.6"
      />
    </svg>
  );
}

export default Spinner;
